import React, { useState } from "react";
import "./answer.css";
import CommentProfile from "../comments/CommentProfile";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import CommentIcon from "@material-ui/icons/Comment";
import MyRespond from "../posts/MyRespond";

// Image
import caret from "../assets/images/caret.png";

function Answers({rootData}) {
  const [isAnswerReadMore, setIsAnswerReadMore] = useState(false);
  const [isOpenChildReply, setIsOpenChildReply] = useState(false);
  return (
    <React.Fragment>
      <div className="comment pb-4">
        <div className="comment_head flex items-center">
          <CommentProfile className="wm-flex-1" rootData={rootData}/>
          <MoreHorizIcon className="cursor-pointer" />
        </div>
        <div className="my-4 flex">
          <div className="votes-Wrapper flex flex-1 flex-col items-center">
            <div className="upVote w-10">
              <img src={caret} alt="caret" className="cursor-pointer" />
            </div>
            <span className=""> 0 </span>
            <div className="downVote w-10">
              <img src={caret} alt="caret" className="cursor-pointer" />
            </div>
          </div>
          <div className="wm-flex-85">
            <pre className="comment_content max-h-48 overflow-hidden whitespace-pre-wrap">
              <p
                className={`mb-0 answerField ${
                  isAnswerReadMore ? "readMoreAnswer" : ""
                }`}
              >
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
                facere distinctio veniam quam nihil mollitia vero qui nostrum
                sint facilis non necessitatibus sit, repudiandae rerum enim
                excepturi officiis eius voluptatem? Lorem ipsum dolor sit amet
                consectetur adipisicing elit. Aliquid facere distinctio veniam
                quam nihil mollitia vero qui nostrum sint facilis non
                necessitatibus sit, repudiandae rerum enim excepturi officiis
                eius voluptatem? Lorem ipsum dolor sit amet consectetur
                adipisicing elit. Aliquid facere distinctio veniam quam nihil
                mollitia vero qui nostrum sint facilis non necessitatibus sit,
                repudiandae rerum enim excepturi officiis eius voluptatem? Lorem
                ipsum dolor sit amet consectetur adipisicing elit. Aliquid
                facere distinctio veniam quam nihil mollitia vero qui nostrum
                sint facilis non necessitatibus sit, repudiandae rerum enim
                excepturi officiis eius voluptatem? Lorem ipsum dolor sit amet
                consectetur adipisicing elit. Aliquid facere distinctio veniam
                quam nihil mollitia vero qui nostrum sint facilis non
                necessitatibus sit, repudiandae rerum enim excepturi officiis
                eius voluptatem?
              </p>
            </pre>
            <span
              className="cursor-pointer select-none text-gray-500 text-sm"
              onClick={() =>
                setTimeout(() => {
                  setIsAnswerReadMore(!isAnswerReadMore);
                }, 200)
              }
            >
              {isAnswerReadMore ? "Read Less" : "Read More"}
            </span>
          </div>
        </div>
        <div className="comment_footer pb-2">
          <div className=" flex justify-between">
            <div className="leftCommentFooter pms-flex-1 flex">
              <div className="commentWrapper mr-3 cursor-pointer">
                <CommentIcon className="mr-2" />
                23
              </div>
            </div>
            <div className="rightCommentFooter">
              <span
                className="cursor-pointer select-none"
                onClick={() => setIsOpenChildReply(!isOpenChildReply)}
              >
                {isOpenChildReply ? `Close` : `Reply`}
              </span>
            </div>
          </div>
          <div className="childAnswer">
            <MyRespond
              className={`mt-4 px-4 childAnswerArea ${
                isOpenChildReply ? "openChildAnswerArea" : ""
              }`}
            />
          </div>
        </div>
        <div className="yourAnswerWrapper mt-4">
          <span className="mb-2 block">Your Answer</span>
          <MyRespond />
        </div>
      </div>
    </React.Fragment>
  );
}

export default Answers;
